import { render } from "./modal-info-saldo.vue?vue&type=template&id=dde6b848"
import script from "./modal-info-saldo.vue?vue&type=script&lang=js"
export * from "./modal-info-saldo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__